/**
 * Utility functions for CSV template generation and download
 */

// Generate CSV template for download (headers with empty rows for data entry)
export const generateCSVTemplate = (): string => {
  const headers = ['isin', 'current_allocation', 'sector (optional)'];
  const emptyRows = 5; // Number of empty rows to add

  const csvContent = [
    headers.join(','),
    ...Array(emptyRows).fill(''), // Add empty rows
  ].join('\n');

  return csvContent;
};

// Download CSV template as a file
export const downloadCSVTemplate = (): void => {
  const csvContent = generateCSVTemplate();
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', 'template.csv');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
